var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6788 15.0558C25.6188 15.6502 26.4815 16.3589 27.247 17.1658C28.497 18.487 29.4808 20.0366 30.1447 21.7299C30.6404 22.9916 30.9598 24.3183 31.0913 25.671C31.1693 26.4659 30.5146 27.1134 29.7169 27.1134H5.87049C5.07272 27.1134 4.41803 26.4645 4.49607 25.671C4.62759 24.3183 4.94699 22.9916 5.4427 21.7299C6.10676 20.0371 7.09057 18.488 8.3404 17.1673C9.10577 16.3599 9.96843 15.6506 10.9086 15.0558M24.6788 15.0558C24.1141 14.6976 23.5227 14.3836 22.9098 14.1164C21.2962 13.4115 19.5545 13.0474 17.7937 13.0469C16.0329 13.0474 14.2911 13.4115 12.6775 14.1164C12.0646 14.3836 11.4732 14.6976 10.9086 15.0558M24.6788 15.0558L27.1733 10.4932M10.9086 15.0558L8.41411 10.4932",
    stroke: "#212427",
    strokeWidth: 2.34282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0966 22.8699C14.0943 22.8699 14.9031 22.0611 14.9031 21.0634C14.9031 20.0657 14.0943 19.2568 13.0966 19.2568C12.0989 19.2568 11.29 20.0657 11.29 21.0634C11.29 22.0611 12.0989 22.8699 13.0966 22.8699Z",
    fill: "#212427"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4906 22.8699C23.4884 22.8699 24.2972 22.0611 24.2972 21.0634C24.2972 20.0657 23.4884 19.2568 22.4906 19.2568C21.4929 19.2568 20.6841 20.0657 20.6841 21.0634C20.6841 22.0611 21.4929 22.8699 22.4906 22.8699Z",
    fill: "#212427"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.f5951188173ea293701503e34059b002.svg";
export { ForwardRef as ReactComponent };